window.SiteReady(($) => {

  console.log('Init Block: Map');

  function initMap($el) {
    let mapStyles = [
      {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#444444"
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#f2f2f2"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 45
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#008aab"
              },
              {
                  "visibility": "on"
              }
          ]
      }
    ];

    let $markers = $el.find('.js-map_marker');

    let mapOptions = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      styles: mapStyles
    };
    let map = new google.maps.Map($el[0], mapOptions);

    map.markers = [];
    $markers.each((index, el) => {
      initMarker($(el), map);
    });

    centerMap(map);

    return map;
  }

  function initMarker($marker, map) {
    let lat = $marker.data('lat');
    let lng = $marker.data('lng');
    let latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };
    let icon = {
      url: THEME_OPTIONS.theme_url + '/public/svg/map_marker.svg',
      size: new google.maps.Size(30, 38),
      scaledSize: new google.maps.Size(30, 38),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(15, 38)
    };

    let marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: icon
    });

    map.markers.push(marker);

    if ($marker.html()) {
      let infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });

      google.maps.event.addListener(marker, 'click', () => {
        infowindow.open(map, marker);
      });
    }
  }

  function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();

    map.markers.forEach((marker) => {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if (map.markers.length == 1) {
      map.setCenter( bounds.getCenter() );
    } else {
      map.fitBounds( bounds );
    }
  }

  //

  $('.js-google_map').each((index, el) => {
    var map = initMap($(el));
  });

});